export enum PermissionsEnum {
    Dashboard= 2032,   
    Inventory= 2033,
    SKUs= 2034,
    Products= 2035,
    VendorItems= 2036,
    Vendors= 2037,
    Purchasing= 2038,
    Forecasting= 2039,
    PurchaseOrders= 2040,
    Forecastingbysku= 2041,
    Shipping= 2042,
    Replenish= 2043,
    Shipments= 2044,
    Logistics= 2045,
    Warehouses= 2046,
    LogisticHistory= 2047,
    Pricing= 2048,
    PricingList= 2049,
    Models= 2050,
    History= 2051,
    Sellers= 2052,
    CostSettings= 2053,
    Orders= 2054,
    SubOrders= 2055,
    Fulfilment= 2056,
    FulfilmentOrders= 2057,
    Batches= 2058,
    Analytics= 2059,
    KPIs= 2060,
    KPIdashboard= 2061,
    ProfitReports= 2062,
    ProfitByDate= 2063,
    ProfitBySKU= 2064,
    SalesReports= 2065,
    Salesbyproduct= 2066,
    Settings= 2067,
    Account= 2068,
    Integrations= 2069,
    Billing= 2070,
    SystemSettings= 2071,
    PurchaseOrdersPlan =  2073,
    FbmOrders = 2074,
    InventorySummary = 2078,
    PoSummary = 2079,
    Settlements = 2080,
    CostDetails = 2081,
    Pl = 2082,
    SalesTrends = 2076,
    OrderList = 2075,
    MonthlySnapshots = 2077,
    ReceivePo  = 2083,
    EditPo = 2084
  }